import { VinylSpinner } from "@/components/vinyl-spinner";
import { ZoomableGalleryImage } from "@/components/zoomable-gallery-image";

export function ReleaseImageLightboxAsset({
  assetLoading,
  assetType,
  assetUrl,
  displaySrcSet,
  displayUrl,
  imageLabel,
  onLoadEnd,
  onNext,
  onPrevious,
  sizes,
  title,
  withNavigation,
}: {
  assetLoading: boolean;
  assetType: ReleaseImage["assetType"];
  assetUrl: string;
  displaySrcSet: string | undefined;
  displayUrl: string;
  imageLabel: string;
  onLoadEnd: () => void;
  onNext: () => void;
  onPrevious: () => void;
  sizes: string;
  title: string;
  withNavigation: boolean;
}) {
  return (
    <>
      {assetLoading && (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
          <VinylSpinner tone="light" className="size-20" />
        </div>
      )}
      {assetType === "pdf" ? (
        <div
          className="h-[90vh] w-[90vw] max-w-5xl overflow-hidden rounded-lg bg-white shadow-2xl"
          onClick={(event) => event.stopPropagation()}
        >
          <iframe
            src={assetUrl}
            title={`${title} - ${imageLabel}`}
            className="h-full w-full border-0 bg-white"
            onLoad={onLoadEnd}
            onError={onLoadEnd}
          />
        </div>
      ) : (
        <ZoomableGalleryImage
          src={displayUrl}
          srcSet={displaySrcSet}
          sizes={sizes}
          alt={`${title} - ${imageLabel}`}
          onLoad={onLoadEnd}
          onError={onLoadEnd}
          onSwipeLeft={withNavigation ? onNext : undefined}
          onSwipeRight={withNavigation ? onPrevious : undefined}
        />
      )}
    </>
  );
}
import type { ReleaseImage } from "@garimpa/api/music/getReleaseImages";
